export const fieldLabels = {
  nameTitle: "Title",
  firstName: "First name",
  surname: "Last name",
  fullName: "Full name",
  telephone: "Telephone",
  email: "Email",
  line1: "Address line 1",
  line2: "Address line 2",
  line3: "Address line 3",
  line4: "Address line 4",
  postCode: "Postcode",
  country: "Country",
  dateReceived: "Date received",
  customerType: "Customer type",
  directorate: "Directorate",
  summaryEnquiry: "Summary of enquiry",
  focusEnquiry: "Focus of enquiry",
  themeEnquiry: "Theme of enquiry",
  category: "Category",
  contactMethod: "Contact method",
  learnerType: "Learner type",
  exceptionalCircumstance: "Exceptional circumstance",
  sourceType: "FOI source",
  caseTypeId: "FOI type",
  complexityType: "Complexity type",
  qualificationTypeId: "Qualification type",
  seriesId: "Series",
  year: "Year",
  informationRequested: "Information requested *",
  summary: "Summary",
  legalInput: "Legal input",
  gqvtq: "GQ/VTQ",
  exemptionsApplied: "Exemptions applied",
  meetingDate: "Event meeting date",
  meetingDateShortLabel: "Date and time",
  foiEventType: "Event type",
  meansOfCommunicationType: "Means of communication",
  wasAttended: "Event attended?",
  message: "Message",
  referenceId: "Reference ID",
  reasonForExtension: "Reason for extension",
  internalReviewOutcomeId: "Internal review outcome",
  icoDecisionNoticeId: "ICO decision notice",
  icoDateReceived: "ICO received date",
  firstTierTribunalOutcomeId: "First tier tribunal outcome",
  firstTierTribunalOutcomeDate: "First tier tribunal outcome date",
  upperTierTribunalOutcomeId: "Upper tier tribunal outcome",
  upperTierTribunalOutcomeDate: "Upper tier tribunal outcome date",
  courtOfAppealOutcomeId: "Court of appeal outcome",
  courtOfAppealOutcomeDate: "Court of appeal outcome date"
};
